import { Translation } from "../i18n-types";

const hr: Translation = {
    "state-is-required": "State is required field.",
    description: {
        "show-more": "Prikaži više",
        "show-less": "Prikaži manje"
    },
    footer: {
        "why-shop-with-us": "Zašto, po Vašim riječima, kupujete kod nas?",
        "heureka-image-url": "/footer/img/hr/comparator.png",
        benefits: {
            first: "Super brza dostava.",
            second: "Vrlo brza i pouzdana usluga.",
            third: "Prijateljski pristup korisničke podrške."
        },
        social: {
            "facebook-plugin-url":
                "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Ffoxigy.hr&tabs&width=314&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId",
            "facebook-page-url": "https://www.facebook.com/foxigy.hr",
            "instagram-page-url": "https://www.instagram.com/foxigy.hr/",
            "youtube-page-url": "https://www.youtube.com/channel/UCWzXz8QOsNR5U4JqJs02JIg"
        },
        "your-foxigy-image-link": "/footer/img/hr/your-foxigy.png"
    }
};

export default hr;
